import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import Confetti from 'react-confetti';

function Result(props) {
  const questionIndex = props.wrong;
  let questionsArray = []
  let questionsOnly = []
  questionIndex.forEach((index) => {
    questionsArray.push(props.quizQuestions[index - 1]);
    questionsOnly.push(props.quizQuestions[index - 1].question);
  });
  let answersArray = []
  questionsArray.forEach(q => {
    q.answers.forEach(answer => {
      if (answer.type === "correct") {
        answersArray.push(answer.content);
      }
    });
  });

  let isMobile = window.innerWidth < 769;
  let confettiWidth = isMobile ? window.innerWidth : "800px";

  let mistakes = <div>
    <p>Congratulations!</p>
    <Confetti
      width={confettiWidth}
      height="200px"
    />
    </div>

  if(questionsOnly.length > 0){
    mistakes = <div>
    <p><strong>Here are the questions you got wrong:</strong></p>
    {questionsOnly.map((question, i) => {
      return (
      <div id="WrongAnswers">
        <p key={i}><strong>Question: </strong>{question}</p>
        <p key={i + 8}><strong>Correct Answer: </strong>{answersArray[i]}</p>
      </div>
    )})}
  </div>

  }
  return (
    <CSSTransitionGroup
      className="container result"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={800}
      transitionLeaveTimeout={500}
      transitionAppear
      transitionAppearTimeout={500}
    >
      <div id="quizResultsNum">
        You got <strong>{props.quizResult}</strong> right!
      </div>
      
      {mistakes}

      <a href="https://magnify.michigandaily.us/election2020/" class="button3"><i class="fas fa-chevron-left"></i> &nbsp;Back to site</a>

    </CSSTransitionGroup>
  )
}

Result.propTypes = {
  quizResult: PropTypes.string.isRequired,
  wrong: PropTypes.array.isRequired,
  quizQuestions: PropTypes.array.isRequired
};

export default Result;
